import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { FinalPage } from "@/features/onboarding/pages/final-page";

export const Route = createFileRoute("/onboarding/_guarded/final")({
	head: () => pageTitle("Welcome to BattMobility!"),
	component: FinalPage,
});
